const wrapUrls = (text: string, newWindow?: boolean) => {
  var urlPattern = /\b(?:https?:\/\/)\S+/gi;
  var target = newWindow === true || newWindow == null ? '_blank' : '';

  return text.replace(urlPattern, function (url) {
    return '<a href="' + url + '" target="' + target + '">' + url + '</a>';
  });
};

export default wrapUrls;
